import { render, staticRenderFns } from "./login-content.vue?vue&type=template&id=8d412816&scoped=true&"
import script from "./login-content.vue?vue&type=script&lang=js&"
export * from "./login-content.vue?vue&type=script&lang=js&"
import style0 from "./login-content.vue?vue&type=style&index=0&id=8d412816&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d412816",
  null
  
)

export default component.exports